module.exports = __webpack_public_path__ + "img/EDC3200_R.e543d161.png";